import { Space } from "@gocardless/flux-react";

import { ForcedPasswordResetMetaData } from "../../SignIn/types";

import { BottomMessage, TopMessage } from "./Messages";

interface ForcedPasswordMessageProps {
  forcedPasswordResetMetaData: ForcedPasswordResetMetaData;
  daysUntilRequiredPasswordReset?: string;
}

export const ForcedPasswordResetMessage = ({
  forcedPasswordResetMetaData,
  daysUntilRequiredPasswordReset,
}: ForcedPasswordMessageProps) => {
  const errorType = forcedPasswordResetMetaData.error_reason;

  return (
    <>
      <TopMessage errorType={errorType} />
      <Space v={1} />
      <BottomMessage
        errorType={errorType}
        daysUntilRequiredPasswordReset={daysUntilRequiredPasswordReset}
      />
    </>
  );
};
